var base = require("./base");
var workroomHelpers = require("./workroomHelpers");

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @return {string} - The provided URL to use when adding a product to the cart
 */
function getAddToCartUrl() {
    if ($(".material-list-add-to-cart-url").val()) {
        return $(".material-list-add-to-cart-url").val();
    }
    return $(".add-to-cart-url").val();
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @param {Object} data - data object used to fill in dynamic portions of the html
 */
function chooseBonusProducts(data) {
    $(".modal-body").spinner().start();

    if ($("#chooseBonusProductModal").length !== 0) {
        $("#chooseBonusProductModal").remove();
    }
    var bonusUrl;
    if (data.bonusChoiceRuleBased) {
        bonusUrl = data.showProductsUrlRuleBased;
    } else {
        bonusUrl = data.showProductsUrlListBased;
    }

    var htmlString = "<!-- Modal -->"
        + "<div class='modal fade' id='chooseBonusProductModal' tabindex='-1' role='dialog'>"
        + "<span class='enter-message sr-only' ></span>"
        + "<div class='modal-dialog choose-bonus-product-dialog' "
        + "data-total-qty='' + data.maxBonusItems + ''"
        + "data-UUID='' + data.uuid + ''"
        + "data-pliUUID='' + data.pliUUID + ''"
        + "data-addToCartUrl='' + data.addToCartUrl + ''"
        + "data-pageStart='0'"
        + "data-pageSize='' + data.pageSize + ''"
        + "data-moreURL='' + data.showProductsUrlRuleBased + ''"
        + "data-bonusChoiceRuleBased='' + data.bonusChoiceRuleBased + ''>"
        + "<!-- Modal content-->"
        + "<div class='modal-content'>"
        + "<div class='modal-header'>"
        + "    <span class=''>" + data.labels.selectprods + "</span>"
        + "    <button type='button' class='close pull-right' data-dismiss='modal'>"
        + "        <span aria-hidden='true'>&times;</span>"
        + "        <span class='sr-only'> </span>"
        + "    </button>"
        + "</div>"
        + "<div class='modal-body'></div>"
        + "</div>"
        + "</div>"
        + "</div>";
    $("body").append(htmlString);
    $(".modal-body").spinner().start();

    $.ajax({
        url: bonusUrl,
        method: "GET",
        dataType: "json",
        success: function (response) {
            var parsedHtml = workroomHelpers.parseHtml(response.renderedTemplate);
            $("#chooseBonusProductModal .modal-body").empty();
            $("#chooseBonusProductModal .enter-message").text(response.enterDialogMessage);
            $("#chooseBonusProductModal .modal-header .close .sr-only").text(response.closeButtonText);
            $("#chooseBonusProductModal .modal-body").html(parsedHtml.body);
            $("#chooseBonusProductModal").modal("show");
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the 'Add to Cart' button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response) {
    $(".minicart").trigger("count:update", response);
    var messageType = response.error ? "alert-danger" : "alert-success";
    // show add to cart toast
    if (response.newBonusDiscountLineItem
        && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    } else {
        if ($(".add-to-cart-messages").length === 0) {
            $("body").append(
                "<div class='add-to-cart-messages'></div>"
            );
        }

        $(".add-to-cart-messages").append(
            "<div class='alert " + messageType + " add-to-basket-alert text-center' role='alert'>"
            + response.message
            + "</div>"
        );

        setTimeout(function () {
            $(".add-to-basket-alert").remove();
        }, 5000);
    }
}

/**
 * toggles visibility of material list icons
 * @param {array} iconArray - the array of icon elements to be toggled
 */
function toggleIcon(iconArray) {
    for (var i = 0; i < iconArray.length; i++) {
        $(iconArray[i]).toggleClass("d-none");
    }
}

/**
 * Displays an error or success message
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} iconEmpty - icon that was clicked to add a product to the list
 * @param {Object} iconFilled - icon that was clicked to remove a product from the list
 */
function displayMessage(data) {
    $.spinner().stop();
    var status;
    if (data.success) {
        status = "alert-success";
    } else {
        status = "alert-danger";
    }

    if ($(".add-to-material-list-messages").length === 0) {
        $("body").append(
            "<div class='add-to-material-list-messages '></div>"
        );
    }
    $(".add-to-material-list-messages")
        .append("<div class='add-to-material-list-alert text-center alert " + status + "'>" + data.msg + "</div>");

    setTimeout(function () {
        $(".add-to-material-list-messages").remove();
    }, 5000);
}

/**
 * toggles the public / private status of the material list or material list item
 * @param {string} listID - the material list ID
 * @param {string} itemID - the material list item ID
 * @param {Object} callback - function to run if the ajax call returns with an
 *                        error so that the checkbox can be reset to it's original state
 */
function updatePublicStatus(listID, itemID, callback) {
    var $publicMaterialListCheckbox = $("#isPublicMaterialList");
    var url = $publicMaterialListCheckbox.data("url");
    $.spinner().start();
    $.ajax({
        url: url,
        type: "post",
        dataType: "json",
        data: {
            listID: listID,
            itemID: itemID
        },
        success: function (data) {
            if (callback && !data.success) {
                callback();
            }
            displayMessage(data);
            if (data.success) {
                var isPublic = $publicMaterialListCheckbox.is(":checked");
                if (isPublic) {
                    $publicMaterialListCheckbox.closest(".material-list-card__footer").find(".ml-social-sharing").removeClass("d-none");
                } else {
                    $publicMaterialListCheckbox.closest(".material-list-card__footer").find(".ml-social-sharing").addClass("d-none");
                }
            }
        },
        error: function (err) {
            if (callback) {
                callback();
            }
            displayMessage(err);
        }
    });
}

/**
 * Removes material tile from saved material list page
 * @param {jQuery} $tileContainer - The element containing the material tile
 * @param {Boolean} isLastItem - (optional) Determines whether the list is now empty
 */
function removeTileFromPage($tileContainer, isLastItem) {
    var newListLength = $(".items-number__length").length ? Number($(".items-number__length").text()) - 1 : $(".material-list-product-tile-container").length - 1;
    $tileContainer.fadeOut(300, function () {
        $tileContainer.remove();
        $(".items-number__length").text(newListLength);

        if (isLastItem) {
            $(".empty__wrapper").removeClass("d-none");
        }
    });
}

/**
 * Adds or removes from the material list
 * @param {jQuery} $button - The add or remove button that was pressed
 */
function updateMaterialList($button) {
    var $parent = $button.closest(".modal-content").length > 0 ? $button.closest(".modal-content") : $button.closest(".material-list-buttons");
    var url = $button.attr("href");
    var pid = $button.data("pid");

    var iconEmpty = [$parent.find(".material-list--add")];
    var iconFilled = [$parent.find(".material-list--remove")];

    if ($parent.hasClass("modal-content")) {
        var $clpTile = $(".material-list-buttons[data-pid='" + pid + "']");
        iconEmpty.push($clpTile.find(".material-list--add"));
        iconFilled.push($clpTile.find(".material-list--remove"));
    }

    var type = "get";
    var data = {};
    if (!url || !pid) {
        return;
    }
    if (!$button.hasClass("material-list--remove")) {
        data = {
            pid: pid
        };
        type = "post";
    } else {
        url += "&pid=" + pid;
    }

    var isLastItem = $(".material-list-product__wrapper").length === 1;

    $.spinner().start();

    $.ajax({
        url: url,
        type: type,
        dataType: "json",
        data: data,
        success: function (response) {
            displayMessage(response);
            if (response.success) {
                if (response.isAccountPage == true) {
                    var $tileContainer = $(".material-list-buttons[data-pid='" + pid + "']").closest(".material-list-product__wrapper");
                    var $dashboardTileContainer = $(".material-list--remove.material-list-btn[data-pid='" + pid + "']").closest(".material-list-item__wrapper");
                    if ($tileContainer.length) {
                        var tileContainerClass = $tileContainer.attr("class");
                        removeTileFromPage($tileContainer, isLastItem);
                        if (response.nextItemTile) {
                            var $tileCol = $("<div/>").addClass(tileContainerClass).html(response.nextItemTile);
                            $(".material-list-account-card .row").append($tileCol);
                        }
                        if (response.removeLoadMore) {
                            $(".material-list-account-card .more-ml-items").remove();
                        }
                    }
                    if ($dashboardTileContainer.length) {
                        removeTileFromPage($dashboardTileContainer, isLastItem);
                        if (!isLastItem) {
                            window.location.reload();
                        }
                    }
                } else {
                    toggleIcon(iconEmpty);
                    toggleIcon(iconFilled);
                }
            }
        },
        error: function (err) {
            displayMessage(err);
        }
    });
}

/**
 * renders the list up to a given page number
 * @param {number} pageNumber - current page number
 * @param {boolean} spinner - if the spinner has already started
 * @param {string} focusElementSelector - selector of the element to focus on
 */
function renderNewPageOfItems(pageNumber, spinner, focusElementSelector) {
    var publicView = $(".materialItemCardsData").data("public-view");
    var listUUID = $(".materialItemCardsData").data("uuid");
    var url = $(".materialItemCardsData").data("href");
    if (spinner) {
        $.spinner().start();
    }
    var scrollPosition = document.documentElement.scrollTop;
    var newPageNumber = pageNumber;
    $.ajax({
        url: url,
        method: "get",
        data: {
            pageNumber: ++newPageNumber,
            publicView: publicView,
            id: listUUID
        }
    }).done(function (data) {
        $(".materialItemCards").empty();
        $("body .materialItemCards").append(data);

        if (focusElementSelector) {
            $(focusElementSelector).focus();
        } else {
            document.documentElement.scrollTop = scrollPosition;
        }
    }).fail(function () {
        $(".more-ml-items").remove();
    });
    $.spinner().stop();
}

function removeWorkroomItemOnDashbord(url) {
    if (url) {
        $.spinner().start();
        $.ajax({
            url: url,
            type: "get",
            dataType: "json",
            data: {},
            success: function () {
                window.location.reload();
            },
            error: function (err) {
                displayMessage(err);
            }
        });
    }
}

module.exports = {
    addToCart: function () {
        $(document).on("click", "button.add-to-cart--workroom", function () {
            var addToCartUrl;
            var removeUrl;

            $("body").trigger("product:beforeAddToCart", this);

            addToCartUrl = getAddToCartUrl();

            var pid = $(this).attr("data-pid");

            var form = {
                pid: pid,
                quantity: 1
            };

            var $cartButton = $(this);
            var isMaterialListLanding = $cartButton.closest(".material-list-landing").length > 0;
            var isLastItem = $(".material-list-product-tile-container").length === 1;

            removeUrl = $(this).data("removeurl");

            $(this).trigger("updateAddToCartFormData", form);
            if (addToCartUrl) {
                $.ajax({
                    url: addToCartUrl,
                    method: "POST",
                    data: form,
                    success: function (data) {
                        handlePostCartAdd(data);
                        $("body").trigger("product:afterAddToCart", data);
                        if ($(".materialList.card.account-card").length) {
                            removeWorkroomItemOnDashbord(removeUrl);
                        };
                        $.spinner().stop();
                        base.miniCartReportingUrl(data.reportingURL);
                        if (isMaterialListLanding) {
                            var $productWrapper = $cartButton.closest(".material-list-product-tile-container");
                            removeTileFromPage($productWrapper, isLastItem);
                        }
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            }
        });
    },

    addToMaterialList: function () {
        $("body").on("click", ".material-list--add", function (e) {
            e.preventDefault();
            updateMaterialList($(this));
        });
    },

    removeFromMaterialList: function () {
        $("body").on("click", ".material-list--remove", function (e) {
            e.preventDefault();
            var $parent = $(this).closest(".modal-content").length > 0 ? $(this).closest(".modal-content") : $(this).closest(".material-list-buttons");
            var dataParent = $parent.hasClass("modal-content") ? ".modal-content" : ".material-list-buttons";
            var pid = $(this).data("pid");
            $(".remove-material-modal .material-list--confirm-removal").data("pid", pid);
            $(".remove-material-modal .material-list--confirm-removal").data("parent", dataParent);
            $(".remove-material-modal .remove-material-modal__specs__sku").text(pid);
            $(".remove-material-modal .remove-material-modal__specs__name").text($(this).data("name"));
        });

        $("body").on("click", ".material-list--confirm-removal", function (e) {
            e.preventDefault();
            var pid = $(this).data("pid");
            var parent = $(this).data("parent");
            var $button = parent === ".modal-content" ? $(parent).find(".material-list--remove") : $(parent + "[data-pid='" + pid + "']").find(".material-list--remove");
            $("#removeMaterialConfirmationModal").modal("hide");
            updateMaterialList($button);
        });
    },

    showDetailsModal: function () {
        $("body").on("click", ".material-details-modal-button", function (e) {
            e.preventDefault();
            var selectedValueUrl = $(this).attr("data-url");
            workroomHelpers.getModalHtmlElement();
            workroomHelpers.fillModalElement(selectedValueUrl);
        });
    },

    moreMLItems: function () {
        $("body").on("click", ".more-ml-items", function () {
            var pageNumber = $(".materialItemCardsData").data("page-number");
            renderNewPageOfItems(pageNumber, true);
        });
    },

    copyWishlistLink: function () {
        $("body").on("click", "#copyShareUrlBtnML", function () {
            var $btn = $("#copyShareUrlBtnML");
            var shareUrl = $btn.data("url");
            navigator.clipboard.writeText(shareUrl);
            $(".ml-copy-link-message").removeClass("d-none");
            setTimeout(function () {
                $(".ml-copy-link-message").addClass("d-none");
            }, 3000);
        });
    },

    toggleListStatus: function () {
        $("#isPublicMaterialList").on("click", function () {
            var listID = $(this).data("id");
            updatePublicStatus(listID, null, null);
        });
    }
};
